import { render, staticRenderFns } from "./JoinButton.vue?vue&type=template&id=cf58187a"
import script from "./JoinButton.vue?vue&type=script&lang=js"
export * from "./JoinButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports